import { Box, Grid, Typography } from '@mui/material';
import FilterAltSharpIcon from '@mui/icons-material/FilterAltSharp';
import { CustomerManagementGridItem } from 'shared/types/customerManagement';
import { useMemo } from 'react';
import { TableInstance } from 'react-table';
import { useUserPermissions } from 'shared/hooks';
import { infoWidgetContentStyles, widgetContainerStyes } from './styles';
import { getControllerUserBrand } from 'shared/utility';
import { useAuthState } from 'shared/stores';
import { useService } from 'shared/providers';

interface Props {
  tableInstance: TableInstance<CustomerManagementGridItem>;
}

export function CustomerManagementGridFilters({ tableInstance }: Props) {
  const { allColumns } = tableInstance;
  const { appConfig } = useService();
  const authState = useAuthState();
  const user = authState.user.get();
  const userPermissions = useUserPermissions();
  const hasCustomerDeletionRequestPermission = userPermissions.includes('abg-retail.customer.request');
  const hasCustomerDeletionApprovePermission = userPermissions.includes('abg-retail.customer.approve');
  const hasControllerPermission = userPermissions.includes('abg-retail.controller');
  const environment = appConfig.environment;
  const userBrands = useMemo(() =>
    hasControllerPermission ?
      getControllerUserBrand(environment, user) :
      null,
    [environment, user, hasControllerPermission]);

  const sortedFilters = useMemo(
    () =>
      [...allColumns].sort((a, b) =>
        a.filterOrder === b.filterOrder ? 0 : Number(a.filterOrder) > Number(b.filterOrder) ? 1 : -1
      )
        .filter(
          c =>
            (c.id !== 'isDeleted') ||
            hasCustomerDeletionRequestPermission || hasCustomerDeletionApprovePermission
        ),
    [allColumns, hasCustomerDeletionApprovePermission, hasCustomerDeletionRequestPermission]
  );
  return (
    <Box sx={{ paddingBottom: 2 }}>
      <Box sx={widgetContainerStyes}>
        <Grid container sx={infoWidgetContentStyles}>
          <Grid container item xs={12}>
            <Grid container item xs={12} spacing={1} sx={{ margin: '0px' }}>
              <Grid item xs={0.5} sx={{ display: 'flex', justifyContent: 'center', flexFlow: 'column' }}>
                <FilterAltSharpIcon />
              </Grid>
              <Grid item xs={11.5} sx={{ display: 'flex', justifyContent: 'center', flexFlow: 'column' }}>
                <Typography variant='body2'>Page Filters</Typography>
              </Grid>
              {sortedFilters
                .filter(c => c.id !== 'abgBrand' || (userBrands && userBrands?.length > 1) || !hasControllerPermission)
                .reduce<JSX.Element[]>((filters, column) => {
                  if (column.canFilter) {
                    filters.push(
                      <Grid
                        item
                        xs={
                          column.id === 'isDeleted'
                            ? 2
                            : hasCustomerDeletionRequestPermission || hasCustomerDeletionApprovePermission
                              ? 2.5
                              : ((hasControllerPermission && userBrands?.length === 1) ? 4 : 3)
                        }
                        key={column.id}
                      >
                        {column.render('Filter')}
                      </Grid>
                    );
                  }
                  return filters;
                }, [])}
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
}
